"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _httpClient = _interopRequireDefault(require("../httpClient"));

var _default = {
  getFeatureFlags: function getFeatureFlags() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/feature_flags';
    return _httpClient.default.get(url);
  },
  getFeatureFlagsServerSide: function getFeatureFlagsServerSide() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/feature_flags';
    return _httpClient.default.get(url, {
      allowOnServer: true
    });
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/experiment/featureFlagService.js
// module id = 4401
// module chunks = 25